import { useState } from 'react'
import { Card, CardBody, Row, Col, UncontrolledTooltip } from 'reactstrap'

function LifetimeTripsSummary({ stats }) {
    const [tripTarget, setTripTarget] = useState(10)

    const lifeTimeTripCount = stats?.lifeTimeTripCount || 0
    const totalCompletedTrips = stats?.totalCompletedTrips || 0
    const lifeTimeTotalEarnings = (typeof stats?.lifeTimeTotalEarnings === 'number' && !isNaN(stats.lifeTimeTotalEarnings))
        ? stats.lifeTimeTotalEarnings.toFixed(2)
        : '0.00'
    const averageEarningsPerTrip = (typeof stats?.averageEarningsPerTrip === 'number' && !isNaN(stats.averageEarningsPerTrip))
        ? stats.averageEarningsPerTrip.toFixed(2)
        : '0.00'
    const weeklyProjectedEarnings = (!isNaN(Number(averageEarningsPerTrip)) && !isNaN(Number(tripTarget)))
        ? (Number(averageEarningsPerTrip) * tripTarget * 7).toFixed(2)
        : '0.00'

    return (
        <Card className="mb-3">
            <CardBody>
                <Row className="text-center">
                    <Col>
                        <div className="text-muted small">Total</div>
                        <div className="h4 fw-bold mt-2">{lifeTimeTripCount}</div>
                    </Col>
                    <Col>
                        <div className="text-muted small">Completed</div>
                        <div className="h4 fw-bold mt-2">{totalCompletedTrips}</div>
                    </Col>
                    <Col>
                        <div className="text-muted small">Lifetime Earnings</div>
                        <div className="h4 fw-bold mt-2">${lifeTimeTotalEarnings}</div>
                    </Col>
                    <Col>
                        <div className="text-muted small">Avg/Trip</div>
                        <div className="h4 fw-bold mt-2">${averageEarningsPerTrip}</div>
                    </Col>
                    <Col>
                        <div className="text-muted small">Trips/Day target</div>
                        <input
                            type="number"
                            min={1}
                            value={tripTarget}
                            onChange={(e) => setTripTarget(parseInt(e.target.value) || 1)}
                            className="h4 fw-bold text-center mt-1"
                            style={{ maxWidth: '80px', color: '#525f7f' }}
                        />
                    </Col>
                    <Col>
                        <div className="text-muted small">
                            Projected
                            <span id="weeklyProjectedEarnings" style={{ display: 'inline-block', marginLeft: '4px' }}>
                                <i
                                    className="fa fa-info-circle"
                                    aria-hidden="true"
                                    style={{ cursor: 'pointer' }}
                                />
                            </span>
                        </div>
                        <div className="h4 fw-bold mt-2">${weeklyProjectedEarnings}</div>
                        <UncontrolledTooltip target="weeklyProjectedEarnings" placement="top">
                            Avg/Trip × Trips/Day target × 7 Days = Projected Weekly Earnings
                        </UncontrolledTooltip>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

export default LifetimeTripsSummary
